import { useNetworkStats } from "@/hooks/useNetworkStats";
import { TotalStake } from "./network-stats/TotalStake";
import { ActiveNodes } from "./network-stats/ActiveNodes";
import { NetworkApr } from "./network-stats/NetworkApr";

export function NetworkStats() {
  const { data, isLoading } = useNetworkStats();

  return (
    <div className="grid gap-4 md:grid-cols-3">
      <TotalStake 
        value={data?.totalStake || 0} 
        isLoading={isLoading} 
      />
      <ActiveNodes 
        value={data?.activeNodesCount || 0} 
        isLoading={isLoading} 
      />
      <div className="cursor-help">
        <NetworkApr 
          apr={data?.apr || 0}
          rewardsPerMinute={data?.rewardsPerMinute || 0}
          isLoading={isLoading}
          tooltipContent={
            <div className="max-w-[300px] p-2">
              <p className="mb-2">The Network APR (Annual Percentage Rate) shows your potential yearly earnings as a percentage of your stake:</p>
              <ul className="list-disc ml-4 space-y-1">
                <li>Calculated daily from actual rewards earned across the network</li>
                <li>Based on the previous day's network performance</li>
                <li>Higher APR means better returns for stakers</li>
              </ul>
              <p className="mt-2 text-sm text-muted-foreground">
                Note: Actual returns may vary based on your node's performance and network conditions
              </p>
            </div>
          }
        />
      </div>
    </div>
  );
}